<!--template html-->
<template>
    <div v-if="message" class="gc-column-content">
        <div class="gc-column-outline">
            <div class="gc-column-text">
                <img class="img-fluid" :class="imageClassName" v-if="hasImage" @load="imageLoaded" :src="message.ImageUrl" alt="Group Card Image" />
                <div class="gc-message-parent">
                    <span v-html="message.Message"></span>
                    <p class="text-right">- {{message.Name}}</p>
                </div>
            </div>
            <!-- gc-column-text -->
        </div>
    </div>
    <!-- gc-column-content -->
</template>
<!--template html-->
<!--script -->
<script>
    export default {
        name: 'GroupCardMessage',
        props: {
            message: Object,
            index: Number
        },
        data: function () {
            return {
                componentHeight: null,
                imageClassName: ""
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getHeight()
            })
        },
        methods: {
            getHeight() {
                if ((!this.message.ImageUrl) || (this.message.ImageUrl.indexOf("no_pic.jpg") > -1))
                    this.componentHeight = this.$el.clientHeight
            },
            imageLoaded(event) {
                let image = event.target

                if (image.clientHeight > 0) {
                    //setting appropriate image class name for 1-column designs
                    if (this.imageClassName === "") {
                        if (((image.clientWidth / image.clientHeight) >= 1.4))
                            this.imageClassName = "gc-cover-image"
                        else
                            this.imageClassName = "gc-tile-image"

                        //get component height based on actual class and loaded image
                        setTimeout(this.getActualClientHeight, 50)
                    }
                }
            },
            getActualClientHeight() {
                this.componentHeight = this.$el.clientHeight
            }
        },
        computed: {
            hasImage: function () {
                if (this.message.ImageUrl) {
                    if (!(this.message.ImageUrl.indexOf("no_pic.jpg") > -1))
                        return true;
                }

                return false;
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
</style>